// Copyright (c) 2017 Deere & Company

import PipCodeRequests from '../state/pip-code-requests';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const resetPipCodeRequests = () => getDefaultState().pipCodeRequests;

const updatePipCodeRequests = (state, action) =>
    PipCodeRequests.update(state, {
        $set: action.data
    });

const updatePipCodeRequestsList = (state, action) => {

    const index = state.findIndex(item => item.id === action.id);

    return PipCodeRequests.update(state, {
        $splice: [
            [
                index,
                1
            ]
        ]
    });

};

export default (state = getDefaultState().pipCodeRequests, action) => {

    const actionTypes = {
        [actions.RESET_TCSM_PIP_CODE_REQUESTS]: resetPipCodeRequests,
        [actions.UPDATE_TCSM_PIP_CODE_REQUESTS]: updatePipCodeRequests,
        [actions.UPDATE_TCSM_PIP_CODE_REQUESTS_LIST]: updatePipCodeRequestsList
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/wip/reducers/pip-code-requests.js